import type { CatalogEntry } from '../types';

/**
 * Onboarding (feature `08`) error codes + catalog.
 *
 * Code shape is `08AAEE` (decimal, zero-padded):
 *   - `AA` = endpoint within the feature (`00` = feature-level / cross-endpoint).
 *   - `EE` = specific condition within that endpoint.
 *
 * Endpoint → `AA` map (OnboardingController):
 *   form=01, status=02, availableSlots=03, calendlyBooked=04.
 *
 * `recordCalendlyBooking` mints a real single-use Calendly booking link
 * server-side (see `CalendlyService.createSingleUseSchedulingLink`) rather
 * than just persisting a client-supplied placeholder — the three codes below
 * cover its validate → mint → persist path.
 */
export const ONBOARDING_CODES = {
  /** calendlyBooked=04. */
  CalendlyBooked: {
    SlotInThePast: '080401',
    NotConfigured: '080402',
    CalendlyRequestFailed: '080403',
  },
} as const;

export const ONBOARDING_CATALOG: Record<string, CatalogEntry> = {
  // ── calendlyBooked ──
  '080401': {
    httpStatus: 400,
    message: 'That time has already passed - please pick another slot.',
  },
  '080402': {
    httpStatus: 503,
    message: "Booking isn't available right now. Please try again later.",
  },
  '080403': {
    httpStatus: 502,
    message: "We couldn't reach our scheduling provider. Please try again.",
  },
};
